/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractMaterial from "App/geometry/material/abstract_material";
import {FLOAT_PRECISION} from "App/math";
import Factory from "App/geometry/material/factory";
import Description from "App/model/description";

export default
class RenderOption extends AbstractMaterial {
    public static TypeName: string = "renderOption";

    public  keepCameraAbove: boolean;
    public  pickable: boolean;
    public  alwaysOnTop: boolean;
    public  isSide: boolean;
    public  isCap: boolean;
    public  notOutline: boolean;

    private polygonOffsetFactor: number;
    private polygonOffsetUnits: number;
    private vertexOrdering: string;
    private culling: boolean;
    private clippable: boolean;
    private glodXOffset: number;
    private glodYOffset: number;

    constructor() {
        super();

        // create default values
        this.parse(null, RenderOption.getDefaultValues());
    }

    public static create() {
        return new RenderOption();
    }

    public static getDefaultValues(): object {
        return {
            polygonOffsetFactor: 0.0,
            polygonOffsetUnits: 0.0,
            vertexOrdering: "UNKNOWN",
            culling: true,
            keepCameraAbove: false,
            pickable: true,
            alwaysOnTop: false,
            isSide: false,
            isCap: false,
            notOutline: false,
            clippable: true,
            glodXOffset: null,
            glodYOffset: null
        };
    }

    public match(aModelDescription: Description, aObject: any): boolean {
        return (
            Math.abs(this.polygonOffsetFactor - aObject.polygonOffsetFactor) < FLOAT_PRECISION &&
            Math.abs(this.polygonOffsetUnits - aObject.polygonOffsetUnits) < FLOAT_PRECISION &&
            this.culling === aObject.culling &&
            this.vertexOrdering === aObject.vertexOrdering &&
            this.keepCameraAbove === aObject.keepCameraAbove &&
            this.pickable === aObject.pickable &&
            this.alwaysOnTop === aObject.alwaysOnTop &&
            this.isSide === aObject.isSide &&
            this.isCap === aObject.isCap &&
            this.notOutline === aObject.notOutline &&
            this.clippable === aObject.clippable &&
            this.glodXOffset === aObject.glodXOffset &&
            this.glodYOffset === aObject.glodYOffset
        );
    }

    public getJSONRepresentation(): object
    {
        let props = {};
        let exportedPropsList = RenderOption.getDefaultValues();
        for (let member in exportedPropsList) {
            props[member] = this[member];
        }

        return props;
    }
}

Factory.register(RenderOption);
